import React from 'react'
import { NavLink } from 'react-router'
import { ChevronRight, LogOut } from 'lucide-react'
import { ACCOUNT_NAV_ITEMS } from './accountNav'

interface AccountNavProps {
  isAdmin: boolean
  onLogout: () => void
  onWatchlistDrill?: () => void
}

function navLinkClass(isActive: boolean): string {
  return `group flex items-center justify-between gap-2 rounded-sm px-2.5 py-1.5 text-sm tracking-wide transition-colors ${
    isActive
      ? 'bg-paper-200 text-ink font-semibold'
      : 'text-ink-500 hover:text-ink hover:bg-paper-200/50'
  }`
}

const chevronClass =
  'h-3.5 w-3.5 shrink-0 text-ink-400 opacity-0 transition-opacity duration-200 group-hover:opacity-100'

const AccountNav: React.FC<AccountNavProps> = ({
  isAdmin,
  onLogout,
  onWatchlistDrill,
}) => {
  const items = ACCOUNT_NAV_ITEMS.filter((item) => !item.adminOnly || isAdmin)

  return (
    <nav aria-label="Kontomenu" className="w-full">
      <ul className="space-y-0.5">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) => navLinkClass(isActive)}
              onClick={() => {
                if (item.drillDown && item.to === '/account/watchlist') {
                  onWatchlistDrill?.()
                }
              }}
            >
              <span>{item.label}</span>
              {item.drillDown && <ChevronRight className={chevronClass} aria-hidden />}
            </NavLink>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={onLogout}
        className="mt-6 inline-flex items-center gap-1.5 text-xs uppercase tracking-wide text-ink-500 hover:text-ink transition-colors"
      >
        <LogOut className="h-3.5 w-3.5" aria-hidden />
        Log ud
      </button>
    </nav>
  )
}

export default AccountNav
